import { useSyncExternalStore } from 'react';

/**
 * Preferência "som de notificação" desta instalação do navegador. NÃO é conteúdo de ninguém (só
 * ligado/desligado), então pode ficar no localStorage; qualquer falha de leitura/escrita
 * (navegação privativa, armazenamento bloqueado) cai para o padrão (ligado).
 */
const KEY = 'inbox:sound';
const listeners = new Set<() => void>();

export function readSoundEnabled(): boolean {
  try {
    return window.localStorage.getItem(KEY) !== 'off';
  } catch {
    return true;
  }
}

export function writeSoundEnabled(enabled: boolean): void {
  try {
    window.localStorage.setItem(KEY, enabled ? 'on' : 'off');
  } catch {
    /* sem armazenamento: vale só até recarregar */
    memory = enabled;
  }
  for (const listener of listeners) listener();
}

let memory: boolean | null = null;
const read = (): boolean => (memory !== null ? memory : readSoundEnabled());

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  const onStorage = (event: StorageEvent): void => {
    if (event.key === KEY) listener();
  };
  window.addEventListener('storage', onStorage);
  return () => {
    listeners.delete(listener);
    window.removeEventListener('storage', onStorage);
  };
}

/** `[ligado, alternar]`: reage a mudanças feitas em outra aba. */
export function useSoundEnabled(): [boolean, (enabled: boolean) => void] {
  const enabled = useSyncExternalStore(subscribe, read, () => true);
  return [enabled, writeSoundEnabled];
}

/** Para testes: esquece o que ficou só em memória. */
export function resetSoundPreferenceMemory(): void {
  memory = null;
}
